/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Nature du bien — valeurs et libellés dans form-rules/property-form.json (champ propertyType)
 */
export const propertyTypeCodeSchema = z.enum(["APPT", "MAIS", "IMMR", "GAPA", "FMCO", "PAGV", "TERR", "BATY"]).describe("Nature du bien — valeurs et libellés dans form-rules/property-form.json (champ propertyType)")